<template>
<div style="width: 100vw; height: 100vh;overflow-y: auto;background: #f6f7f8;overflow-x: hidden">
  <van-nav-bar @click-left="onClickLeft" :border="false">
    <span slot="left" style="font-size: 17px">
       <van-icon color="black" name="arrow-left"></van-icon>
    </span>
    <span slot="title" style="font-size: 17px;color: #505050">订单详情</span>
  </van-nav-bar>
  <div style="padding: 3.2vw 6.13vw 4.8vw;background: white">
    <div style="display: flex;justify-content: space-between">
      <div style="font-weight: bold">
        <div style="position: relative;font-size: 4.27vw;color: #333333">
          订单信息
          <div style="position: absolute; left: -2.8vw;top: 1.4vw;height: 3.2vw;width:  .8vw;border-radius: 999px;background: #da3939"></div>
        </div>
        <div style="margin-top: 4.8vw;font-size: 3.73vw;color: #535353">
          订单号: {{orderInfo.orderNo}}
        </div>
        <div style="margin-top: 4.8vw;font-size: 3.73vw;color: #535353">
          下单时间: {{$utils.ymdDate(orderInfo.orderTime, '-')}}
        </div>
        <div style="margin-top: 4.8vw;font-size: 3.73vw;color: #535353">
          下单件数: {{orderInfo.orderItemLists.length}}件
        </div>
      </div>
      <div>
        <img src="../../assets/img/order/shzImg.png" v-if="orderInfo.orderStatus === 1" style="width: 20.8vw;margin-top: 5.07vw">
        <img src="../../assets/img/order/yshImg.png" v-if="orderInfo.orderStatus === 2" style="width: 20.8vw;margin-top: 5.07vw">
        <img src="../../assets/img/order/yfkImg.png" v-if="orderInfo.orderStatus === 3" style="width: 20.8vw;margin-top: 5.07vw">
        <img src="../../assets/img/order/yqxImg.png" v-if="orderInfo.orderStatus === 0" style="width: 20.8vw;margin-top: 5.07vw">
        <div style="margin-top: 3.2vw;color: #9d2727;font-size: 3.73vw;font-weight: bold">
          共计：{{totalPrice.toFixed(2)}}元
        </div>
      </div>
    </div>
    <div style="margin-top: 10vw;width: 100%" @click="toEdit" v-if="orderInfo.orderStatus === 5">
      <div style="margin: 0 auto;width: 60vw;text-align: center;height: 10vw;border: .13vw solid #e25455;color: #e25455;line-height: 10vw;border-radius: 1.33vw;font-size: 3.7vw">修改订单</div>
    </div>
    <div style="width: 100%;margin-top: 2vw;font-size: 2.47vw" class="centerBox">
      {{orderInfo.orderStatus !== 5 ? '订单已导出不能修改' : ''}}
    </div>
  </div>
  <div style="padding: 4.8vw 3.2vw 4.8vw">
    <div class="shopCardList" v-for="item in orderInfo.orderItemLists" :key="item.id" style="width: 100%; display: block; box-shadow: none;background: white">
      <div style="margin: 0;width: 100%;height: 100%;display: flex">
        <div style="position: relative; width: 25.07vw; height: 25.07vw; display: inline-block;border-radius: .8vw; overflow: hidden">
          <div style="background-color: #ffffff; height: 100%; width: 100%">
            <img :src="item.img" style="width: 100%; height: 100%">
          </div>
        </div>
        <div class="shopListInfo" style="margin-left: 3.73vw">
          <div style="font-size: 3.73vw; width: 55vw; margin-top: 2.4vw;font-weight: bold">
                      {{item.goodsName}}
<!--            精品红油-->
          </div>
          <div style="justify-content: left;margin: 2.87vw 0 3.07vw;color: #ababab;font-size: 2.67vw">
            {{item.goodsDesc}}
          </div>
          <div  class="shopCardMoney" style="margin-bottom: 0;line-height: 5.33vw;height: 5.33vw">
            <div>
              <span style="font-size: 3.47vw;letter-spacing: -.3vw;">￥</span><span style="font-size: 4vw;font-weight: bold">{{$utils.priceFormat(item.unitPrice * item.qty)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="position: absolute; right: 4.8vw;bottom: 1.4vw" class="shopListStepper">
        x{{item.qty}}
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'index',
  data: function () {
    return {
      show: false,
      icon: {},
      totalPrice: 0,
      orderInfo: {
        orderItemLists: []
      },
      isFreightShow: false,
      couponShow: false,
      orderShow: false,
      userData: {}
    }
  },
  created () {
    this.orderById()
    // this.userInfo()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    orderPop () {
      this.show = true
    },
    toEdit () {
      let b = 1
      // 当前时间戳
      // const data = new Date().getTime() + ''
      // if (data > window.localStorage.getItem('orderStartTime') && data < window.localStorage.getItem('orderEndTime')) {
      // } else {
      //   this.$toast('未在下单时间范围内')
      //   b--
      // }
      if (b) {
        this.$router.push({
          path: '/orderShopSearch',
          query: {
            orderId: this.$route.query.id,
            orderlist: this.orderInfo.orderItemLists
          }
        })
      }
    },
    orderById () {
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.listOrder({
        id: this.$route.query.id
      })
        .then((response) => {
          this.$toast.clear()
          this.totalPrice = 0
          this.orderInfo = response.data[0]
          this.orderInfo.orderItemLists.forEach(item => {
            this.totalPrice += item.unitPrice * item.qty / 100
          })
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>

</style>
